// Copyright (C) 2021 Intel Corporation
//
// SPDX-License-Identifier: MIT

import { FilterPreset } from 'reducers/interfaces';
import { clamp } from 'utils/math';

function sanitize(value: number, min: number, max: number): number {
    return Number.isFinite(value) ? clamp(value, min, max) : 100;
}

// Presets may be loaded from unvalidated localStorage, so clamp them to the supported slider ranges.
export function clampFilterPreset(preset: FilterPreset): FilterPreset {
    return {
        brightness: sanitize(preset.brightness, 50, 200),
        contrast: sanitize(preset.contrast, 50, 200),
        saturation: sanitize(preset.saturation, 0, 300),
    };
}
